export default __webpack_public_path__ + "static/media/atlanta.5795f573.png";